var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "discipline-summary-modal" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "discipline-summary-modal",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: {
            show: _vm.onShowModal,
            close: function ($event) {
              _vm.localActive = false
            },
          },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "discipline-summary-modal-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: {
                click: function ($event) {
                  _vm.localActive = false
                },
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "discipline-summary-modal-header",
              class: {
                "discipline-summary-modal-header-red":
                  _vm.type === "fines" || _vm.type === "fouls",
                "discipline-summary-modal-header-green": _vm.type === "bonuses",
              },
            },
            [
              _c(
                "div",
                { staticClass: "discipline-summary-modal-header-title" },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _c(
                "div",
                { staticClass: "discipline-summary-modal-header-count" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "discipline-summary-modal-header-count-text",
                    },
                    [_vm._v(" " + _vm._s(_vm.getCountForHeader()) + " ")]
                  ),
                ]
              ),
              _vm.type === "fines" || _vm.type === "fouls"
                ? _c(
                    "div",
                    { staticClass: "discipline-summary-modal-header-amount" },
                    [
                      _vm._v(" " + _vm._s(_vm.getCommonAmount()) + " "),
                      _vm.type === "fines"
                        ? _c("span", [_vm._v(" " + _vm._s(_vm.currencyLabel))])
                        : _vm._e(),
                      _vm.type === "fouls"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.getFoulsSummaryWord())),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { staticClass: "discipline-summary-modal-search" },
            [
              _c("c-input", {
                staticClass: "discipline-summary-modal-search-input",
                attrs: {
                  id: "discipline-summary-modal-search-input",
                  placeholder: "Поиск",
                  icon: "search",
                  type: "text",
                  clearable: true,
                },
                model: {
                  value: _vm.searchLocal,
                  callback: function ($$v) {
                    _vm.searchLocal = $$v
                  },
                  expression: "searchLocal",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "discipline-summary-modal-items",
              attrs: { id: "discipline-summary-modal-items" },
              on: { scroll: _vm.setShadowSummaryItems },
            },
            [
              _vm._l(_vm.itemsLocal, function (item, index) {
                return _c(
                  "div",
                  {
                    key: `discipline-item-${index}`,
                    staticClass: "discipline-summary-modal-items-item",
                  },
                  [
                    item.isShow
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "discipline-summary-modal-items-item-desc",
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "discipline-summary-modal-items-item-block",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "discipline-summary-modal-items-item-block-count",
                                },
                                [_vm._v(" " + _vm._s(item.count) + " ")]
                              ),
                              item.summ !== null
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "discipline-summary-modal-items-item-block-amount",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatAmount(item.summ) || 0
                                          ) +
                                          " "
                                      ),
                                      _vm.type === "fines"
                                        ? _c("span", [
                                            _vm._v(
                                              " " + _vm._s(_vm.currencyLabel)
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.type === "fouls"
                                        ? _c("span", [_vm._v(" б.")])
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              _vm.isShowSearchEmptyMessage
                ? _c(
                    "div",
                    { staticClass: "discipline-summary-modal-items-empty" },
                    [_vm._v("Совпадений не найдено")]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c("div", {
            staticClass: "discipline-summary-modal-items-shadow-bottom",
            attrs: { id: "discipline-summary-modal-items-shadow-bottom" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }